/* eslint-disable import/extensions */
import React, { Component } from 'react';
import { Form, Row, Col, Input, DatePicker, Spin } from 'antd';
import moment from 'moment';
// eslint-disable-next-line import/extensions
import { connect } from 'dva';
import Container from '@/components/Container';
import ListPage from '../../../../components/ListPage'
import styles from './index.less';

const { RangePicker } = DatePicker;
const { ListTable } = ListPage

@connect(({ operationLog }) => ({
  ...operationLog,
}))
class OperationLog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      date: null,
      // currentPage: 1,
      columns: [
        {
          title: '操作时间',
          dataIndex: 'operateDate',
          key: 'operateDate',
        },
        {
          title: '操作人',
          dataIndex: 'operateUserName',
          key: 'operateUserName',
        },
        {
          title: '操作IP',
          dataIndex: 'ip',
          key: 'ip',
        },
        {
          title: '操作位置',
          dataIndex: 'operatePage',
          key: 'operatePage',
        },
        {
          title: '操作类型',
          dataIndex: 'operateType',
          key: 'operateType',
        },
        {
          title: '相关数据',
          width: 300,
          dataIndex: 'operateContent',
          key: 'operateContent',
        },
      ],
    };
  }

  componentDidMount() {
    this.handleSearch();
  }

  handleSearch = (page, pageSize) => {
    const { date } = this.state;
    const { dispatch, form, } = this.props;
    const { getFieldsValue } = form;

    const { searchField } = getFieldsValue();
    let [startDate, endDate] = date || [];

    if (startDate) {
      startDate = startDate.format('YYYY-MM-DD');
    }
    if (endDate) {
      endDate = endDate.format('YYYY-MM-DD');
    }

    const params = {
      searchField,
      startDate,
      endDate,
      page:page || 1,
      pageSize:pageSize || 10,
    };

    dispatch({
      type: 'operationLog/search',
      params,
    });
  };

  handleChange = searchDate => {
    const { pageSize } = this.props
    this.setState(
      {
        date: searchDate,
      },
      () => this.handleSearch(1, pageSize)
    );
  };

  // 修改页码
  handleChangePagination = (page, pageSize) => {
    const { dispatch } = this.props
    dispatch({
      type:'operationLog/save',
      payload:{
        page: page || 1,
        pageSize: pageSize || 10
      }
    })
    this.handleSearch(page, pageSize)
  };

  render() {
    const { columns = [] } = this.state;
    const { form, data = [], spinProps, totalElements, page, pageSize } = this.props;

    const { getFieldDecorator } = form;

    const formItemLayout = {
      colon: false,
      labelCol: {
        xs: { span: 6 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 18 },
        sm: { span: 18 },
      },
    };

    const tableProps = {
      columns,
      list: data,
      rowKey: 'id',
      pageInfo: {
        page,
        totalElements,
      },
      onPageChange:this.handleChangePagination
    };

    // const isIFrame = window.location.href.indexOf('v2/operationLog') === -1;

    return (
      <Container breStates>
        <div className={styles['operation-log']}>
          <div className="container">
            <Spin {...spinProps}>
              <Form className="ant-advanced-search-form header">
                <Row>
                  <Col span={10} style={{ display: 'block' }}>
                    <Form.Item {...formItemLayout} label="操作时间">
                      {getFieldDecorator(`date`)(<RangePicker onChange={this.handleChange} />)}
                    </Form.Item>
                  </Col>
                  <Col span={7} style={{ display: 'block' }}>
                    <Form.Item label="相关数据" {...formItemLayout}>
                      {getFieldDecorator(`searchField`)(
                        <Input placeholder="请输入内容搜索" onPressEnter={() => this.handleSearch(1, pageSize)} />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </Form>

              <div className="content">
                <ListTable {...tableProps} />
              </div>
            </Spin>
          </div>
        </div>
      </Container>
    );
  }
}

export default Form.create()(OperationLog);
